import React, { useState } from 'react';

import OcrReader from '../utils/OcrReader';

function IApopup() {
    const tabs = ['OCR', 'IA'];
    const [selectedTab, setSelectedTab] = useState('OCR');
    const [previousTab, setPreviousTab] = useState('OCR');

    const handleTabClick = (tab) => {
        if (tab !== selectedTab) {
            setPreviousTab(selectedTab);
            setSelectedTab(tab);
        }
    };

    const selectedIndex = tabs.indexOf(selectedTab);
    const previousIndex = tabs.indexOf(previousTab);
    const direction = selectedIndex > previousIndex ? 'right' : 'left';

    return (
        <div
            className="bg-white p-4 rounded-[17px] overflow-auto text-black"
            style={{ width: 'calc(100% - 10px)', height: 'calc(100% - 10px)' }}
            onClick={(e) => e.stopPropagation()}
        >
            {/* Tabs */}
            <div className="flex flex-nowrap justify-center items-center space-x-2 mb-4 text-white">
                {tabs.map((tab) => {
                    const isActive = selectedTab === tab;
                    return (
                        <button
                            key={tab}
                            className={`py-3 px-10 text-sm font-semibold rounded-lg transition-all duration-500 ease-in-out
                                ${isActive
                                    ? 'bg-orange-600 border-b-2 border-orange-500 text-white animate-gradientWave'
                                    : 'text-gray-600 bg-gray-100 hover:text-orange-400'}`}
                            style={{
                                background: isActive
                                    ? 'linear-gradient(270deg, #F96F29, #F9B429, #F98429, #F96F29, #F9B429)'
                                    : undefined,
                                backgroundSize: isActive ? '600% 600%' : undefined,
                            }}
                            onClick={() => handleTabClick(tab)}
                        >
                            {tab}
                        </button>
                    );
                })}
            </div>

            {/* Slideable content */}
            <div className="relative w-full h-full overflow-hidden">
                <div
                    className="top-0 left-0 absolute flex w-full h-full transition-transform duration-500 ease-in-out"
                    style={{
                        transform: `translateX(${selectedTab === 'OCR' ? '0%' : '-100%'})`,
                    }}
                >
                    {/* OCR content */}
                    <div className="flex flex-col flex-shrink-0 justify-start items-center gap-4 w-full">
                        <h2 className="font-bold text-gray-800 text-xl">Analyse de Document SAV (OCR)</h2>

                        {/*
                        <label className="flex flex-col justify-center items-center p-6 border-2 border-gray-300 hover:border-orange-500 border-dashed rounded-md w-4/5 transition-all cursor-pointer">
                            <span className="text-gray-500 text-sm text-center">
                                Glissez un fichier ici ou cliquez pour sélectionner
                            </span>
                            <input
                                type="file"
                                className="hidden"
                                accept=".pdf,image/*"
                                onChange={(e) => {
                                    const file = e.target.files[0];
                                }}
                            />
                        </label>

                        <button
                            onClick={() => {
                                // Lancer l'analyse OCR
                                console.log('Lancer l’analyse OCR');
                            }}
                            className="bg-orange-500 hover:bg-orange-600 px-6 py-2 rounded-full font-semibold text-white transition-all"
                        >
                            Lancer l’analyse OCR
                        </button> */}

                        <OcrReader />

                    </div>

                    {/* IA content */}
                    <div className="flex flex-shrink-0 justify-center items-center w-full">
                        <div className="text-black text-center">Contenu IA</div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default IApopup;
